// extracted by mini-css-extract-plugin
module.exports = {"TableWrapper":"TableWrapper___3bAI6"};